import { apiClient } from "../config";

async function deleteReportVersion(id: any) {
  const res = await apiClient.delete(`/admin/reports/${id}/version`);
  return res.data;
}

export default deleteReportVersion;
